function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.698 14.229c-.537 0-.704.485-.982.962l-4.488 5.775H2.73c-.608 0-1.087.429-1.087.962v31.758c0 .533.479.962 1.087.962h50.56c.608 0 1.086-.429 1.086-.962V21.928c0-.533-.478-.962-1.087-.962H39.79l-4.488-5.775c-.338-.435-.444-.962-.981-.962z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.912 37.245c0 7.13-5.777 12.912-12.903 12.912s-12.903-5.78-12.903-12.912c0-7.13 5.777-12.912 12.903-12.912s12.903 5.78 12.903 12.912z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.912 37.245c0 7.13-5.777 12.912-12.903 12.912s-12.903-5.78-12.903-12.912c0-7.13 5.777-12.912 12.903-12.912s12.903 5.78 12.903 12.912z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1.643 32.193H15.97M40.014 32.193h14.361"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.009 27.14c-3.7 0-6.936 1.978-8.695 4.947a10.106 10.106 0 00-1.403 5.158c0 5.58 4.521 10.105 10.098 10.105s10.098-4.524 10.098-10.105c0-1.88-.51-3.65-1.402-5.158a10.085 10.085 0 00-8.696-4.947z",
  strokeLinecap: "square"
}));

var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Camera.c2f5a81f.svg";
export { ForwardRef as ReactComponent };